const defaultCurrentConfigurationCopyTabIndex = 0

const state = {
  currentConfigurationCopyTabIndex: defaultCurrentConfigurationCopyTabIndex
}

const getters = {}

const mutations = {
  SET_CURRENT_CONFIGURATION_COPY_TAB_INDEX: (state, payload) => {
    state.currentConfigurationCopyTabIndex = payload
  }
}

const actions = {
  setCurrentConfigurationCopyTabIndex({ commit }, currentTabIndex) {
    commit('SET_CURRENT_CONFIGURATION_COPY_TAB_INDEX', currentTabIndex)
  },
  clearCurrentConfigurationCopyTabIndex({ commit }) {
    const defCurrentConfigurationCopyTabIndex = 0
    commit(
      'SET_CURRENT_CONFIGURATION_COPY_TAB_INDEX',
      defCurrentConfigurationCopyTabIndex
    )
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
